document.querySelectorAll('.tabs button').forEach(function (b) {
  b.addEventListener('click', function () {
    document.querySelectorAll('.tabs button').forEach(function (x) { x.classList.remove('on'); });
    b.classList.add('on');
    ['p1', 'p2', 'p3'].forEach(function (id) {
      document.getElementById(id).hidden = (id !== b.dataset.p);
    });
  });
});
